import type { FaireProductEntity } from "../../entity_types/product";

export const p_5m7pzsrxua: FaireProductEntity = {
  token: "p_5m7pzsrxua",
  type: "product",
  name: "Lt. Blue Drink On The River Sweatshirt",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/8e5b426cdb298c0fc6691c7b43554b7e5c5a649f0ceecfa71559da4e4d9d64b8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f02678797bd6526a20114d1d029f4a439e55d5f8e32f63284da373ef24121e4e.jpeg",
    "https://cdn.faire.com/fastly/dcf29caf303d9373633bbdd0dbac33e9b44681fbe19bc330f033efe2d8df3406.jpeg",
    "https://cdn.faire.com/fastly/c1de15fd5eba32c33a9c72fab3113919791edcdd92f1cce66f9051fb1113ab02.jpeg",
    "https://cdn.faire.com/fastly/454181ad167518ce8b5ad3841c82c86dbb56aa34b5baad062668c3f24b0db7cb.jpeg",
  ],
  priceDollars: 33,
  description:
    "Light blue graphic sweatshirt\n\nMulticolor “It’s a Good Day to Drink on the River” graphic on the front\n\nSoft fleece interior, relaxed fit\n\nRibbed cuffs and hem, crew neckline\n\n50% Cotton, 50% Polyester\n\nPre-pack 2-2-2-2 (S-XL)\n\nMin. Qty: 8",
  tags: [],
  msrpDollars: 82.51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:44.282Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
